import React, { forwardRef } from 'react';
import { IconButton, Button, Icon } from '@picsio/ui';
import { Close, Infobox } from '@picsio/icons';
import { func, shape, string } from 'prop-types';
import localization from '../../shared/strings';
import hintStyles from './styles.module.scss';

const BestMatchSearchHint = forwardRef((props, ref) => {
  const {
    onClose, text, styles = {}, onClick,
  } = props;

  return (
    <div
      className={hintStyles.banner}
      ref={ref}
      style={styles}
    >
      <Icon size="lg" className={hintStyles.bannerIcon}>
        <Infobox />
      </Icon>
      <div className={hintStyles.bannerText}>{text}</div>
      <Button
        onClick={onClick}
        className={hintStyles.bannerActionText}
        type="text"
        color="secondary"
        id="applyBestMatch"
      >
        {localization.BEST_MATCH_SEARCH.buttonText}
      </Button>
      <IconButton id="closeApplyBestMatch" buttonSize="lg" size="xl" className={hintStyles.bannerClose} onClick={onClose}>
        <Close />
      </IconButton>
    </div>
  );
});

BestMatchSearchHint.propTypes = {
  onClose: func.isRequired,
  text: string.isRequired,
  styles: shape({}),
  onClick: func.isRequired,
};

BestMatchSearchHint.defaultProps = {
  styles: {},
};

export default BestMatchSearchHint;
